import { useParams } from "react-router";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useHtzSummaryShowQuery } from "@/services/backend/htz/summary/api/summary-api";
import { SummaryDataCard } from "@/services/backend/htz/summary/components/summary-data-card";
import { SummaryCoverLetterCard } from "@/services/backend/htz/summary/components/summary-cover-letter-card";
import { CardSkeleton } from "@/shared/components/card-skeleton";

export function DataRoute() {
  const { summaryId } = useParams();
  const { data } = useHtzSummaryShowQuery({ id: summaryId! });

  if (!data) return <CardSkeleton />;

  return (
    <div className="space-y-2">
      <SummaryDataCard id={data.id} disabled={isImmutable(data)} />
      <SummaryCoverLetterCard id={data.id} disabled={isImmutable(data)} />
    </div>
  );
}
